import * as Yup from "yup";
import { isValidPhoneMask } from "Utils/Phone";
import { isCPF } from "Services/schema/validations";
import { isFutureDate, isValidDate } from "Utils/Date";

export const validationSchema = Yup.object().shape({
  email: Yup.string().email("E-mail inválido").required("E-mail é obrigatório"),
  name: Yup.string().required("Nome é obrigatório"),
  attach: Yup.mixed(),
  cpf: Yup.string()
    .test("validateCpf", "CPF inválido", isCPF)
    .required("CPF é obrigatório"),
  birthDate: Yup.string()
    .required("Data de nascimento é obrigatória")
    .test("Data inválida", "Data inválida", isValidDate)
    .test(
      "Data é maior que a data atual",
      "Data é maior que a data atual",
      isFutureDate
    ),
  phone: Yup.string()
    .test("phone", "Telefone inválido", (value) => isValidPhoneMask(value))
    .required("Telefone é obrigatório"),
  weight: Yup.string(),
  height: Yup.string(),
  gender: Yup.string().required("Gênero biológico é obrigatório"),
  motherName: Yup.string(),
  cep: Yup.string().required("CEP é obrigatório"),
  street: Yup.string().required("Rua é obrigatória"),
  number: Yup.string().required("Número é obrigatório"),
  complement: Yup.string(),
  obs: Yup.string(),
  neighborhood: Yup.string().required("Bairro é obrigatório"),
  city: Yup.string().required("Cidade é obrigatória"),
  state: Yup.string()
    .matches(/^[A-Z]{2}$/, "Estado deve ter 2 letras (UF)")
    .required("Estado (UF) é obrigatório"),
});
